import { render, staticRenderFns } from "./ActionsRenderer.vue?vue&type=template&id=2ec54eff&scoped=true&"
import script from "./ActionsRenderer.vue?vue&type=script&lang=js&"
export * from "./ActionsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec54eff",
  null
  
)

export default component.exports